import type { CanvasScript } from '@/cowork/omniad/api/coworkApi';

/** The script as plain text, for copying into a brief or a message. */
export const scriptAsText = (title: string, s: CanvasScript) => `${title} · ${s.seconds} s\n\n${s.rows.map((r) => `${r.seconds} s\nSAY: ${r.say || '—'}\nSHOOT: ${r.shoot || '—'}${r.onScreen ? `\nON SCREEN: ${r.onScreen}` : ''}`).join('\n\n')}`;
